import { FuelType } from '../fleet-vehicle/fuel-type.enum';
import { GearType } from './gear-type.enum';

export class CarModel {
	id: number;
	brand: string;
	model: string;
	motorFuelType: FuelType;
	version: string;
	body: string;
	carSegment: string;
	gearType: GearType;
	seats: number;
	doors: number;
	maxSpeed: number;
	euroMotor: string;
	wheelDrive: string;
	codice_eurotax: number;
	id_dbmotori: string;
	wltpNedc: string;
	price: number;
	leasingPrice: number;

	co2EmissionUrban: number;
	co2EmissionHighway: number;
	co2EmissionCombined: number;
	fuelConsumptionUrban: number;
	fuelConsumptionHighway: number;
	fuelConsumptionCombined: number;

	wltpConsumptionUrbanCold: number;
	wltpConsumptionHighwayCold: number;
	wltpConsumptionCombinedCold: number;
	wltpConsumptionUrbanMild: number;
	wltpConsumptionHighwayMild: number;
	wltpConsumptionCombinedMild: number;
	realConsumptionUrbanCold: number;
	realConsumptionHighwayCold: number;
	realConsumptionCombinedCold: number;
	realConsumptionUrbanMild: number;
	realConsumptionHighwayMild: number;
	realConsumptionCombinedMild: number;

	wltpRangeUrbanCold: number;
	wltpRangeHighwayCold: number;
	wltpRangeCombinedCold: number;
	wltpRangeUrbanMild: number;
	wltpRangeHighwayMild: number;
	wltpRangeCombinedMild: number;
	realRangeUrbanCold: number;
	realRangeHighwayCold: number;
	realRangeCombinedCold: number;
	realRangeUrbanMild: number;
	realRangeHighwayMild: number;
	realRangeCombinedMild: number;

	electricalMotorEfficiency: number;
	batteryCapacity: number;
	batteryUsable: number;
	batterySlowPortType: string;
	batterySlowChargePower: number;
	batterySlowChargeSpeed: number;
	batteryFastPortType: string;
	batteryFastChargePower: number;
	batteryFastChargeSpeed: number;
}
